<template>
  <page>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">

      <!-- BEGIN: Subheader -->
      <div class="m-subheader ">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <h1 class="m-subheader__title ">{{$t('My attachments')}}</h1>
          </div>
        </div>
      </div>
      <!-- END: Subheader -->
      <div class="m-content m-content-ls">
        <div class="m-portlet m-portlet--full-height  ">
          <div class="m-portlet__body">
            <p v-if="description" v-html="description"></p>
            <div class="row">
              <div class="col">
                <div id="button-wrapper" class="button-wrapper" v-b-tooltip.hover.top="{ disabled: canAddAttachments }"
                     :title="addButtonTitle">
                  <b-button class="btn"
                            @click="$bvModal.show('uppy')"
                            :class="[canAddAttachments && 'btn-ls', !canAddAttachments && 'btn-default disabled']"
                            :disabled="!canAddAttachments">
                    {{$t('Add Attachments')}}
                  </b-button>
                </div>
                <b-modal v-if="canAddAttachments" id="uppy" hide-footer centered lazy
                         body-class="padding-0">
                  <uppy @upload-success="fetchAttachments" @complete-success="$bvModal.hide('uppy')"/>
                </b-modal>
              </div>
            </div>
            <b-table class="margin-top-20 w-auto"
                     bordered
                     stacked="md"
                     hover
                     show-empty
                     :fields="fields"
                     :empty-text="$t('No attachments')"
                     :items="attachments">
              <template v-slot:cell(file_name)="data">
                <div class="overflow-break">{{ data.item.file_name }}</div>
              </template>
              <template v-slot:cell(date_add)="data">
                {{ data.item.date_add }}
              </template>
              <template v-slot:cell(uuid)="data">
                <div style="width: 75px">
                  <button class="btn btn-sm btn-outline-ls m-btn--hover-ls" v-b-tooltip.hover.top :title="$t('Download')"
                          @click="download(data.item.uuid, data.item.file_name)">
                    <i class="fa fa-download"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-danger m--margin-left-5" v-b-tooltip.hover.top :title="$t('Delete')"
                          @click="remove(data.item.uuid)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {isIosApp} from "@/utils/Pwa";


export default {
    name: "AttachmentsPage",
    components: {
      Uppy: () => import("../utils/Uppy.vue"),
      Page: () => import("./Page")
    },
    data() {
      return {
        fields: [
          {
            key: 'uuid',
            label: this.$t('Actions'),
          },
          {
            key: 'file_name',
            label: this.$t('File Name'),
            sortable: true
          },
          {
            key: 'date_add',
            label: this.$t('Created At'),
            sortable: true
          },
        ]
      }
    },
    mounted() {
      this.fetchAttachments();
    },
    methods: {
      ...mapActions([
        'fetchAttachments'
      ]),
      remove(uuid) {
        this.$http.delete(`attachments/${uuid}`)
          .then(() => this.fetchAttachments())
          .catch(() => {
          })
      },
      download(uuid, name) {
        this.$http.get(`attachments/download/${uuid}`, {responseType: 'blob'})
          .then((r) => {
            let blob = new Blob([r.data]);
            if (isIosApp) {
              var reader = new FileReader();
              reader.fileName = name
              reader.onload = function(){
                window.location.href = reader.result;
              }
              reader.readAsDataURL(blob);
            }
            else{
              let link = document.createElement("a");
              link.download = name;
              link.href = URL.createObjectURL(blob);
              link.click();
              URL.revokeObjectURL(link.href);
            }
          }).catch(() => {
        })
      },
    },
    computed: {
      ...mapState({
        attachments: state => state.attachments.attachments,
        description: state => state.settings.attachments.description,
        attachmentsLimit: state => state.settings.attachments.maxFiles,
        hasFreeSpace: state => state.settings.attachments.hasFreeSpace,
      }),
      canAddAttachments() {
        return this.attachments.length < this.attachmentsLimit && this.hasFreeSpace;
      },
      addButtonTitle() {
        if (this.canAddAttachments && this.hasFreeSpace) {
          return '';
        }

        return !this.hasFreeSpace
            ? this.$t('Data limit exceeded')
            : this.$t('Max attachment limit')
      },
    },
  }
</script>

<style scoped>
  .button-wrapper {
    width: 136px;
  }
  .overflow-break {
    overflow-wrap: break-word;;
  }
</style>
